export const SET_PROJECTS_LIST = 'SET_PROJECTS_LIST'
export const SET_TAGS = 'SET_TAGS'
export const SET_LIST_OF_REQUEST_TAGS = 'SET_LIST_OF_REQUEST_TAGS'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_QUERY_PROJECTS = 'SET_QUERY_PROJECTS'
export const SET_FULL_PROJECTS_LIST = 'SET_FULL_PROJECTS_LIST'
export const SET_USERS_LIST_PROJECTS = 'SET_USERS_LIST_PROJECTS'
export const SET_CLIENTS_LIST_PROJECTS = 'SET_CLIENTS_LIST_PROJECTS'
export const SET_TIMER = 'SET_TIMER'
export const SET_START_TIMER = 'SET_START_TIMER'
export const SET_PAUSE_TIMER = 'SET_PAUSE_TIMER'
export const SET_ACTIVE_TIMER = 'SET_ACTIVE_TIMER'
export const SET_SHOW_TIMER_MODAL = 'SET_SHOW_TIMER_MODAL'
export const SET_SHOW_TIMER_MODAL_FINANCE = 'SET_SHOW_TIMER_MODAL_FINANCE'
export const SET_SHOW_TIMER = 'SET_SHOW_TIMER'
export const SET_STEPS_LIST = 'SET_STEPS_LIST'
export const SET_REQUESTS_LIST = 'SET_REQUESTS_LIST'
export const SET_REQUESTS_LIST_DECLINED = 'SET_REQUESTS_LIST_DECLINED'
export const SET_REQUESTS_LIST_FORWARD = 'SET_REQUESTS_LIST_FORWARD'
export const SET_PROJECT_USER_ID = 'SET_PROJECT_USER_ID'
export const SET_CLIENT_COMPANIES = 'SET_CLIENT_COMPANIES'
export const SET_REMINDERS = 'SET_REMINDERS'
export const SET_SHOW_PANEL = 'SET_SHOW_PANEL'
export const SET_PICKER_OPEN = 'SET_PICKER_OPEN'
export const SET_TYPE_SERVICE_LIST = 'SET_TYPE_SERVICE_LIST'

export const SET_REMOVED_PROJECT_STEPS = 'SET_REMOVED_PROJECT_STEPS'



// WEBPACK FOOTER //
// ./src/constants/mutationTypes.js